import {
	checkoutSessionResponseSchema,
	stripeAccountResponseSchema,
	stripeConnectResponseSchema,
	stripeDashboardLinkResponseSchema,
} from "../../schemas/finance";
import { fetchApi, fetchVoid } from "../client/internal";

export const stripe = {
	getAccount: (clubId: string) => fetchApi(`/${clubId}/stripe`, stripeAccountResponseSchema),
	connect: (clubId: string, data: { return_url: string; refresh_url: string }) =>
		fetchApi(`/${clubId}/stripe`, stripeConnectResponseSchema, {
			method: "POST",
			body: JSON.stringify(data),
		}),
	disconnect: (clubId: string) => fetchVoid(`/${clubId}/stripe`, { method: "DELETE" }),
	dashboardLink: (clubId: string) =>
		fetchApi(`/${clubId}/stripe/dashboard`, stripeDashboardLinkResponseSchema),
	createCheckoutSession: (
		clubId: string,
		invoiceId: string,
		data: { success_url: string; cancel_url: string },
	) =>
		fetchApi(`/${clubId}/invoices/${invoiceId}/checkouts`, checkoutSessionResponseSchema, {
			method: "POST",
			body: JSON.stringify(data),
		}),
};
